import { AssociationTypeService } from '../../../shared/services/assoc-type.service';
import { Inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AssocType } from '../../../shared/models/assoc-type.interface';


export class AssociationTypesResolver implements Resolve<AssocType[]> {

    constructor(@Inject(AssociationTypeService) private service: AssociationTypeService) { }

    resolve(route: ActivatedRouteSnapshot): Observable<AssocType[]> {
        return this.service.list();
    }
}
